// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AbUAM3tNr2wp8r {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 96px;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
  color: var(--ds-surface, #ffffff);
  font-size: 16px;
  line-height: 20px;
}
.AbUAM3tNr2wp8r:hover {
  background-color: var(--ds-background-neutral, #091e420f);
}
.AbUAM3tNr2wp8r:focus-within {
  outline-offset: 2px;
  outline: var(--ds-border-focused, #388bff) auto 2px;
}
.mac .AbUAM3tNr2wp8r:focus-within {
  outline-color: -webkit-focus-ring-color;
}
.AbUAM3tNr2wp8r:focus-within .mac.firefox {
  outline-color: AccentColor;
}
.hPB1MFHtrhA_in {
  display: block;
  box-sizing: border-box;
  height: 100%;
  padding: 8px;
  color: #ffffff;
  text-decoration: none;
}
.hPB1MFHtrhA_in:hover {
  color: #ffffff;
  text-decoration: none;
}
.hPB1MFHtrhA_in:focus {
  outline: none;
}
.dm_OiRwZWIDM2G {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.dm_OiRwZWIDM2G._AkfOWB3Zyup8p {
  background-color: hsla(0, 0%, 0%, 0.15);
}
.dm_OiRwZWIDM2G.zKtQ7Ng1uMVj8Q {
  background-color: hsla(0, 0%, 0%, 0.3);
}
.AbUAM3tNr2wp8r:hover ._AkfOWB3Zyup8p {
  background-color: hsla(0, 0%, 0%, 0.25);
}
.AbUAM3tNr2wp8r:hover .zKtQ7Ng1uMVj8Q {
  background-color: hsla(0, 0%, 0%, 0.4);
}
.DIkCJzvVP3VODq {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
}
.f8GN4mNvr_EWAE {
  display: inline-block;
  flex: 0 0 auto;
  width: 100%;
  max-height: 40px;
  overflow: hidden;
  font-weight: bold;
  text-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  word-wrap: break-word;
}
.mcVwRsjgoqbKKD {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.XfHA7DTUV8LDET {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  line-height: 16px;
}
.DDT5e9tugZiiNZ {
  --ds-icon: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0;
  margin-left: auto;
  overflow: hidden;
  transition-property: width;
  transition-duration: 0.15s;
}
.DDT5e9tugZiiNZ.cWtf4RhPbGmDgR {
  width: 20px;
}
.AbUAM3tNr2wp8r:hover .DDT5e9tugZiiNZ {
  width: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `AbUAM3tNr2wp8r`,
	"link": `hPB1MFHtrhA_in`,
	"boardTileOverlay": `dm_OiRwZWIDM2G`,
	"dark": `_AkfOWB3Zyup8p`,
	"light": `zKtQ7Ng1uMVj8Q`,
	"boardDetails": `DIkCJzvVP3VODq`,
	"boardName": `f8GN4mNvr_EWAE`,
	"badges": `mcVwRsjgoqbKKD`,
	"visiblityContainer": `XfHA7DTUV8LDET`,
	"starContainer": `DDT5e9tugZiiNZ`,
	"isStarred": `cWtf4RhPbGmDgR`
};
export default ___CSS_LOADER_EXPORT___;
